<template>
  <div class="user-menu">
    <Icon class="member" name="member"></Icon>
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        {{ username }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown"><el-dropdown-item command="quitLogin">退出登录</el-dropdown-item></el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { removeToken,removeInfo } from '@/utils/auth';
import USERAPI from '@/api/user'
export default {
  data() {
    return {};
  },
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleCommand(command){
      eval("this."+command+"()");
    },
    //退出登录
    quitLogin() {
      USERAPI.logout().then(res=>{
        removeToken();
        this.$router.push({
          path: '/login'
        });
      })
    }
  }
};
</script>
<style scoped lang="scss">
.user-menu {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .member{
      top: 0px;
      position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/usermenu.vue